module.exports = __webpack_public_path__ + "img/icon-right.16617b2b.png";